import styled from 'styled-components'

export const PageTitle = styled.h1`
  margin-bottom:40px;
`